/**
 * Turn sections into tabs (Elementor)
 * Adds data attributes to section and `anchornav` to container
 * Contianer will scope the tabs so we can have multiple per page
 * CSS to be added manually but
 *
 * Markup:
 * .anchornav
 * 	[data-anchornav-section="one"]
 * 	[data-anchornav-section="two"]
 * 	[data-anchornav-section="three"]
 * 	...
 */

// Get container for each tab component
const anchornavs = document.querySelectorAll('.anchornav')

anchornavs.forEach((anchornav) => {


	// Get all Sections
	const sections = anchornav.querySelectorAll('[data-anchornav-section]')

	if (sections.length > 0) anchornav.classList.add('anchornav-populated')

	// Make tabs
	const tabs = []

	sections.forEach((section) => {
		// sanitized ID based on dataset
		section.id = section.dataset.anchornavSection.replace(/\s|\./g, '-')

		// Tab Names (e.g 'Localsearch.com.au' or 'SEO')
		const tab = section.dataset.anchornavSection

		tabs.push(tab)
	})

	// Add tabs to DOM
	let tabsContainer = document.createElement('div')

	tabsContainer.classList.add('anchornav-buttons')

	tabs.forEach((tab) => {
		const tabslug = tab.replace(/\s|\./g, '-')
		tabsContainer.innerHTML += `<a href="#${tabslug}" data-anchornav-section-target="${tab}" class="anchornav-button"> ${tab}</a> `
	})

	anchornav.insertBefore(tabsContainer, anchornav.firstChild)

	const buttons = anchornav.querySelectorAll('.anchornav-button')

	//Mark active button
	const observer = new IntersectionObserver(
	  (entries) => {
		entries.forEach((entry) => {
  
		  if (entry.isIntersecting) {
			buttons.forEach((button) => {
						  // reset all
			  button.classList.remove('anchornav-button-active') 
  
						  // activate matching id
			  button.hash === '#' + entry.target.id
				? button.classList.add('anchornav-button-active')
				: button.classList.remove('anchornav-button-active')
			})
		  }
		})
	  },
	  { threshold: 1 }
	)
  
	  sections.forEach(section => observer.observe(section))

	sections.forEach((section) => {
		if (section.classList.contains('anchornav-section-active')) {
			anchornav
				.querySelector(
					`[data-anchornav-section-target="${section.dataset.anchornavSection}"]`
				)
				?.classList.add('anchornav-button-active')
		}
	})

	buttons.forEach((button) => {
		button.addEventListener('click', (e) => {
			// Get this section target
			let section = anchornav.querySelector(
				`[data-anchornav-section="${e.target.dataset.anchornavSectionTarget}"]`
			)

			// reset all buttons
			buttons.forEach((button) =>
				button.classList.remove('anchornav-button-active')
			)

			// reset all sections
			sections.forEach((section) =>
				section.classList.remove('anchornav-section-active')
			)

			// activate this button
			button.classList.add('anchornav-button-active')

			// activate this section
			section.classList.add('anchornav-section-active')
		})
	})
})
